import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../../shared.module';

@Component({
    selector: 'app-single-modal',
    templateUrl: './single-modal.component.html',
    styleUrls: ['./single-modal.component.scss'],
    imports: [SharedModule]
})
export class SingleModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
